import { render, staticRenderFns } from "./ChurchPane.vue?vue&type=template&id=17dfcd9e&scoped=true&"
import script from "./ChurchPane.vue?vue&type=script&lang=js&"
export * from "./ChurchPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dfcd9e",
  null
  
)

export default component.exports